import { Component, Input, input, output, ChangeDetectionStrategy } from "@angular/core";
import { NgClass, NgStyle, NgTemplateOutlet } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SpinComponent } from "common/spin/spin.component";

export interface LoadingSpinConfiguration {
	color?: string;
	showIconInLoadingSpin: boolean;
	size?: string;
}

@Component({
	selector: "stages-button",
	templateUrl: "./button.component.html",
	imports: [NgClass, TranslateModule, SpinComponent, NgStyle, NgTemplateOutlet],
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["button.component.scss"],
})
export class ButtonComponent {
	readonly buttonType = input<string>("button");

	readonly ariaLabel = input<string>();
	protected showIconInLoadingSpin: boolean = false;
	protected loadingSpinSize: string = "s";
	protected loadingSpinColor?: string;

	readonly title = input<string>("no title provided");

	readonly doNotTranslate = input<boolean>(false);

	readonly disabled = input<boolean>(false);

	readonly buttonClasses = input<string>("button sm");

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	iconClasses?: string;

	readonly showIconOnly = input<boolean>(false);

	readonly translateTitle = input<boolean>(true);

	readonly hasNoButtonShape = input<boolean>(false);

	readonly buttonStyle = input<Record<string, string | null>>({});

	readonly iconStyle = input<Record<string, string | null>>({});

	@Input()
	set loadingSpinConfiguration(configuration: LoadingSpinConfiguration) {
		this.showIconInLoadingSpin = configuration.showIconInLoadingSpin;
		if (configuration.size) {
			this.loadingSpinSize = configuration.size;
		}
		if (configuration.color) {
			this.loadingSpinColor = configuration.color;
		}
	}

	readonly isIconOnly = input<boolean>(false);

	readonly showLoadingSpin = input<boolean>(false);

	readonly showAsPlainText = input<boolean>(false);

	readonly clicked = output<boolean>();

	readonly buttonTranslateParams = input<{
		ARG0: string;
	}>(); //aligned parameter name with parammeter name of menu component. Needed for split button components menu items

	protected getButtonCSS(): string {
		if (this.hasNoButtonShape()) {
			return "button flat";
		}

		if (this.showIconInLoadingSpin) {
			return "button-with-spin";
		}

		return this.buttonClasses() ?? "sm";
	}
}
